module.exports = __webpack_public_path__ + "img/introduce1.82b89e00.png";